import './App.css';
import AppProvider from './context/AppProvider';
import Main from './pages/main/Main'
import Load from './pages/load/Load';
import Modal from './pages/modal/Modal';

const App = () => {

    return (
        <AppProvider>
            <div className="App dark">
                <Load />
                <Main />
                <Modal />
            </div>
        </AppProvider>
    )
}

export default App;
